import { useState } from "react"
import ModalImage, { Lightbox } from "react-modal-image"
import Collection from "../V2Leaderboard/Collection"

function SimilarProduct({ product, addSimilarProductToCollection, allCollectionNames, fetchCollections, collectionSets, }) {

  const [showLightbox, setShowlightbox] = useState(false)
  const stopOnlineClickPropagation = (e) => {
    e.stopPropagation()
  }
  return <div className="lg:h-[90%] relative  group mr-0.5 lg:min-w-60 grow-0 text-xs shrink-0">

    {showLightbox ? <Lightbox
      medium={product.imageUrl}
      large={product.imageUrl}
      onClose={() => {
        setShowlightbox(false)
      }}
    /> : null}

    <div className="absolute top-0 left-0 w-full h-14">
      <Collection image={product} collections={allCollectionNames} addImageToCollection={addSimilarProductToCollection} collectionSets={collectionSets} fetchCollections={fetchCollections} />
    </div>
    <img loading="lazy" src={product.imageUrl} className="h-44 lg:h-full " onClick={() => {
      setShowlightbox(true)
    }} />
    <div className="w-full p-2 block group-hover:block lg:absolute bottom-0 bg-slate-100/60 z-10 " onClick={stopOnlineClickPropagation}>
      {product.productUrl ? <p><a target='_blank' href={product.productUrl} className="underline font-semibold text-blue-600">product-link</a> </p> : null}
      {product.brand ? <p><span className="underline font-semibold">Brand : </span><a href={product.productUrl} target='_blank'>{product.brand}</a> </p> : null}
      <p><span className="underline font-semibold">Geography : </span> {product.geography}</p>
      {product.price ? <p><span className="underline font-semibold">INR : </span> {product.price}</p> : null}
      {product.countOfReviews && !isNaN(parseInt(product.countOfReviews)) ? <p><span className="underline font-semibold">Reviews : </span> {product.countOfReviews}</p> : null}
      <p><span className="underline font-semibold">Match : </span> {product.match}</p>
      {product.preferred ? < p > <span className="underline font-semibold">Preferred Design : </span> {product.preferred ? 'Yes' : 'No'}</p> : null}
    </div>
  </div>
}

export default SimilarProduct
